import React from "react";
import { Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import {
  faXmarkCircle,
  faCircleRight,
} from "@fortawesome/free-regular-svg-icons";

import "./transmission-program.scss";

function TransmissionProgram(props) {
  const { items, handleRemoveSwitch, blockRemove } = props;

  return (
    <div className="transmission-program-container">
      <div className="transmission-program-header">
        <div className="transmission-program-item-header">
          <div className="transmission-program-date title">Time</div>
          <div className="transmission-program-selected-date title">
            Program
          </div>
        </div>
      </div>
      <div className="transmission-program">
        <div className="transmission-program-line"></div>

        {items?.map((item, index) => (
          <TransmissionProgramCard
            blockRemove={blockRemove}
            item={item}
            handleRemoveSwitch={() => handleRemoveSwitch(index)}
            key={"transmission_program_" + item.id}
          />
        ))}
      </div>
    </div>
  );
}

export default TransmissionProgram;

function TransmissionProgramCard(props) {
  const switchTypeOptions = {
    Initial: "Initial",
    Following: "Following",
    FixedTime: "Fixed Time",
    // StartImmediate: "Start Immediate",
  };

  const { item, handleRemoveSwitch, blockRemove } = props;
  const timeAmPm =
    item.time == null
      ? "Following"
      : item.time !== `On Start`
        ? moment(item.time, "HH:mm").format("h:mm A")
        : item.time;

  return (
    <div key={item.time} className="transmission-program-item">
      <div className="transmission-program-date">{timeAmPm}</div>
      <div className="transmission-program-card-container">
        <div className="transmission-program-card-content">
          <div className="transmission-program-title">
            {item.title}
            <div className="transmission-delete">
              {!item.blocked && !blockRemove && (
                <FontAwesomeIcon
                  className="fa-regular"
                  style={{ color: "#FF2222", fontSize: "1rem" }}
                  icon={faXmarkCircle}
                  onClick={handleRemoveSwitch}
                />
              )}
            </div>
          </div>
          <div className="transmission-program-selected-date">
            {item.type && (
              <>
                <div className="">
                  <FontAwesomeIcon
                    className="fa-regular"
                    style={{ fontSize: "1rem" }}
                    icon={faCircleRight}
                  />
                </div>
                <div className="type-schedule">
                  {switchTypeOptions[item.type]}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <div className="transmission-program-text">{item.title}</div> */}
    </div>
  );
}
